(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.__vyseraFeaturedProductShowcaseQuantityBundleSync) {
    window.__vyseraFeaturedProductShowcaseQuantityBundleSync = true;

    const syncBundleColorFields = (form, quantity) => {
      const colorMix = form?.querySelector('[data-bundle-color-mix]');
      if (!colorMix) return;

      const bundleSize = Number(quantity);
      const visibleFieldCount = bundleSize === 2 || bundleSize === 3 ? bundleSize : 0;
      colorMix.hidden = visibleFieldCount === 0;
      colorMix.classList.toggle('is-three-pack', visibleFieldCount === 3);

      const heading = colorMix.querySelector('[data-bundle-color-heading]');
      if (heading) {
        heading.textContent = visibleFieldCount === 3 ? 'Farben für dein 3er-Familien-Set' : 'Farben für dein 2er-Sparset';
      }

      colorMix.querySelectorAll('[data-bundle-color-field]').forEach((field) => {
        const fieldSize = Number(field.dataset.bundleColorField);
        const isVisible = fieldSize <= visibleFieldCount;
        field.hidden = !isVisible;
        field.style.display = isVisible ? '' : 'none';
        field.querySelectorAll('[data-bundle-color-input]').forEach((input) => {
          input.disabled = !isVisible;
        });
      });
    };

    const syncBundleOption = (bundle, quantity) => {
      const form = bundle?.closest('form');
      if (!bundle || !form) return;

      bundle.querySelectorAll('[data-quantity-bundle-option]').forEach((option) => {
        const input = option.querySelector('[data-quantity-bundle-input]');
        option.classList.toggle('is-selected', input?.dataset.bundleQuantity === String(quantity));
      });

      syncBundleColorFields(form, quantity);
    };

    document.querySelectorAll('[data-quantity-bundle]').forEach((bundle) => {
      const selectedInput = bundle.querySelector('[data-quantity-bundle-input]:checked');
      if (selectedInput) {
        syncBundleOption(bundle, selectedInput.dataset.bundleQuantity || selectedInput.value);
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.matches('[data-quantity-bundle-input]')) return;

      const bundle = target.closest('[data-quantity-bundle]');
      const form = bundle?.closest('form');
      const quantityInput = form?.querySelector('input[name="quantity"]');
      if (!bundle || !quantityInput) return;

      const quantity = target.dataset.bundleQuantity || target.value;
      const quantitySelector = quantityInput.closest('quantity-selector-component');

      if (typeof quantitySelector?.setValue === 'function') {
        quantitySelector.setValue(quantity);
      } else {
        quantityInput.value = quantity;
      }

      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (typeof quantitySelector?.onQuantityChange === 'function') {
        quantitySelector.onQuantityChange();
      }
      if (typeof quantitySelector?.updateButtonStates === 'function') {
        quantitySelector.updateButtonStates();
      }

      syncBundleOption(bundle, quantity);
    });
  }

  if (!window.__vyseraColorVariantSync) {
    window.__vyseraColorVariantSync = true;

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.matches('[data-fps-color-input]')) return;

      const picker = target.closest('[data-fps-color-picker]');
      const form = target.closest('form') || picker?.closest('.fps-info-col')?.querySelector('form');
      const variantInput = form?.querySelector('input[ref="variantId"]');
      const variantId = target.dataset.variantId;
      if (!picker || !variantInput || !variantId) return;

      variantInput.value = variantId;
      const selectedColor = picker.querySelector('[data-fps-selected-color]');
      if (selectedColor) selectedColor.textContent = target.value;

      picker.closest('.fps-buybox-card')?.querySelectorAll('[data-express-add-to-cart]').forEach((button) => {
        button.dataset.variantId = variantId;
        if (button.dataset.expressLoading !== 'true') button.disabled = false;
      });

      const variantImage = target.dataset.variantImage;
      const mainImage = picker.closest('.fps-buybox-card')?.querySelector('.fps-main-image');
      if (mainImage && variantImage) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = variantImage;
        mainImage.alt = target.dataset.variantImageAlt || `${target.value} ErgoDuo Sitzkissen`;
      }

      picker.querySelectorAll('[data-fps-color-option]').forEach((option) => {
        option.classList.toggle('is-selected', option.contains(target));
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
